import { Trans } from '@lingui/macro'
import { CalendarTodayOutlined, Check, Close, DeleteOutlined, MoveDownOutlined, RemoveRedEyeOutlined } from '@mui/icons-material'
import {
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  Typography
} from '@mui/material'
import { dateFormat } from 'app/appSettings'
import moment from 'moment'
import React from 'react'
import { INDEX_OF_DONE, INDEX_OF_FAILED, INDEX_OF_IN_PROGRESS } from './ActionPlan'

const postponeDays = [14, 30, 90]

const ActionPlanBoardCard = ({
  card,
  cardActions,
  column,
  index,
  columns,
  deleting
}) => {
  const title = card.title
  const date = moment(card.dueDate).format(dateFormat)
  const [anchorEl, setAnchorEl] = React.useState(null)
  return (
    <div className='scrum-board-card'>
      <Menu
        onClose={() => {
          setAnchorEl(null)
        }}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
      >
        {postponeDays.map(numDays => {
          return (
            <MenuItem
              key={numDays}
              className='mr-4 text-small'
              fontSize='small'
              onClick={e => {
                e.stopPropagation()
                cardActions.postponeAction(numDays, column.index, index)
                setAnchorEl(null)
              }}
            >
              <Trans>Postpone {numDays} days</Trans>
            </MenuItem>
          )
        })}
      </Menu>
      <div className='px-16 py-12'>
        <Typography className='card-header'>{title}</Typography>
        <Typography className='date-label'>{date}</Typography>
        <div className='flex flex-middle flex-space-between button-group text-small'>
          <Grid className='flex' container direction='row' gap='16px'>
            <Tooltip title={<Trans>Edit action description</Trans>}>
              <span><IconButton
                disabled={deleting}
                onClick={e => {
                  e.stopPropagation()
                  cardActions.openDialog({
                    ...card,
                    columnIndex: column.index,
                    cardIndex: index
                  })
                }}
                size='small'
              >
                <RemoveRedEyeOutlined className='action-icon' />
              </IconButton></span>
            </Tooltip>

            {column.index !== INDEX_OF_IN_PROGRESS && (
              <Tooltip title={<Trans>Mark action as In Progress</Trans>}>
                <span><IconButton
                  disabled={deleting}
                  onClick={e => {
                    e.stopPropagation()
                    cardActions.moveAction({
                      source: {
                        index
                      },
                      destination: {
                        index: columns[INDEX_OF_IN_PROGRESS].actions.length
                      },
                      targetColumnIndex: INDEX_OF_IN_PROGRESS,
                      sourceColumnIndex: column.index
                    })
                  }}
                  size='large'
                >
                  <MoveDownOutlined className='action-icon' />
                </IconButton></span>
              </Tooltip>
            )}

            {column.index !== INDEX_OF_DONE && (
              <Tooltip title={<Trans>Mark action as done</Trans>}>
                <span><IconButton
                  disabled={deleting}
                  onClick={e => {
                    e.stopPropagation()
                    cardActions.moveAction({
                      source: {
                        index
                      },
                      destination: {
                        index: columns[INDEX_OF_DONE].actions.length
                      },
                      targetColumnIndex: INDEX_OF_DONE,
                      sourceColumnIndex: column.index
                    })
                  }}
                  size='large'
                >
                  <Check className='action-icon' />
                </IconButton></span>
              </Tooltip>
            )}

            {column.index !== INDEX_OF_FAILED && (
              <Tooltip title={<Trans>Mark action as failed</Trans>}>
                <span><IconButton
                  disabled={deleting}
                  onClick={e => {
                    e.stopPropagation()
                    cardActions.moveAction({
                      source: {
                        index
                      },
                      destination: {
                        index: columns[INDEX_OF_FAILED].actions.length
                      },
                      targetColumnIndex: INDEX_OF_FAILED,
                      sourceColumnIndex: column.index
                    })
                  }}
                  size='large'
                >
                  <Close className='action-icon' />
                </IconButton></span>
              </Tooltip>
            )}
            <Tooltip title={<Trans>Postpone action</Trans>}>
              <span><IconButton
                disabled={deleting}
                onClick={e => {
                  setAnchorEl(e.target)
                  e.stopPropagation()
                }}
                size='large'
              >
                <CalendarTodayOutlined className='action-icon' />
              </IconButton></span>
            </Tooltip>

            <Tooltip title={<Trans>Delete action</Trans>}>
              <span><IconButton
                disabled={deleting}
                onClick={e => {
                  e.stopPropagation()
                  cardActions.deleteAction(card, index, column.index)
                }}
                size='large'
              >
                <DeleteOutlined className='action-icon' />
              </IconButton></span>
            </Tooltip>
          </Grid>
        </div>
      </div>
    </div>
  )
}

export default ActionPlanBoardCard
